import React from 'react';
import { isNull } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import CardLayout from '@magoosh/layouts/card';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import ProgressBar from '@magoosh/lib/progress_bar';
import { pluralize } from 'utilities/pluralize';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  hint?: string;
  previousScore: number;
  score: number;
  scoreRange: {
    max: number;
    min: number;
  };
  status: string;
  title?: string;
}

export default (props: Props) => {
  return (
    <CardLayout.Card borderGradient className="d-flex flex-column gap-m">
      <div className="align-items-center d-flex gap-xxs">
        <h3 className="u-margin-A-n">
          {props.title || 'Score'}
          {(() => {
            if (props.status === 'finished') {
              return <>{' '}<strong>{isNull(props.score) ? 'NS' : props.score}</strong></>;
            } else {
              return null;
            }
          })()}
        </h3>

        {
          props.hint && (
            <div className="d-flex flex-1 justify-content-end">
              <OverlayTrigger
                placement="left"
                overlay={
                  <Tooltip id={`tooltip-score-card`}>
                    {props.hint}
                  </Tooltip>
                }
              >
                <div>
                  <FontAwesomeIcon className="small text-gray-light" icon="info-circle" />
                </div>
              </OverlayTrigger>
            </div>
          )
        }
      </div>

      <div className="d-flex flex-column gap-s">
        <div className="align-items-center d-flex gap-s">
          <div className="flex-1" style={{ minWidth: 250 }}>
            <ProgressBar
              backgroundColor={colors.grayLighter}
              color="linear-gradient(90deg, rgb(55, 145, 237), rgb(113, 78, 246))"
              percentage={props.score ? (props.score / props.scoreRange.max) * 100 : 0}
              size="md"
            />
          </div>

          <div className="flex-none small">
            out of {props.scoreRange.max}
          </div>
        </div>

        {(() => {
          if (!props.previousScore || !props.score) {
            return null;
          } else if (props.previousScore == props.score) {
            return (
              <small>About the same as your last attempt</small>
            );
          } else if (props.previousScore > props.score) {
            return (
              <small>{pluralize(props.previousScore - props.score, 'point')} lower than your last attempt</small>
            );
          } else {
            return (
              <small>🎉 {pluralize(props.score - props.previousScore, 'point')} higher than your last attempt</small>
            );
          }
        })()}
      </div>
    </CardLayout.Card>
  );
}
